import React from 'react';
import { useAuth } from './AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { session, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!session) {
        // User is not logged in, redirect to login page.
        // Pass the current location so we can redirect back after login.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // User is logged in, render the requested page.
    return <>{children}</>;
};

export default ProtectedRoute;
